import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { NgxSpinner } from 'ngx-spinner';
import { from, Observable } from 'rxjs';
import { ApiConfig } from './api.config.service';

@Injectable()
export class TranslationLoader implements TranslateLoader {
  constructor(
    private http: HttpClient,
    private config: ApiConfig,
    private spinner: NgxSpinner
  ) {}

  getTranslation(lang: string): Observable<any> {
    const path = `${this.config.portalApiUrl}/api/storage/translation/${lang}`;
    try {
      //this.spinner.show = true;
      return this.http.get<any>(path);
    } finally {
      //this.spinner.show = false;
    }
  }
}
